import { InputHTMLAttributes } from "react";
import Image from "next/image";
import { useField } from "formik";
import { cn } from "../../../../utils";

type CheckboxInputProps = InputHTMLAttributes<HTMLInputElement> & {
  label?: string;
  name: string;
  labelClassName?: string;
};

const CheckboxInput = ({
  label,
  name,
  className,
  children,
  labelClassName,
  ...props
}: CheckboxInputProps) => {
  const [field, meta] = useField({ ...props, name });

  return (
    <span
      className={cn(
        "relative w-full flex items-baseline bg-white input-wrapper input-wrapper--checkbox",
        {
          [className as string]: !!className,
        },
      )}
    >
      {meta.error !== undefined ? (
        <Image
          width={8}
          height={8}
          className="flex absolute top-1/2 -mt-2 -left-8"
          src="/images/asterix.svg"
          alt="asterix"
        />
      ) : null}
      {label === "children" ? (
        // TODO: destructuring id seems to break checkbox
        <label
          className={cn("flex relative pl-9 cursor-pointer select-none", {
            [labelClassName as string]: !!labelClassName,
          })}
          htmlFor={props.id || name}
        >
          <input
            className="absolute opacity-0 pointer h-0 w-0"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...field}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
          <span className="absolute top-1/2 left-0 h-6 w-6 -mt-3 border border-solid border-grey rounded bg-white [label_input:checked_~_&]:bg-[url('/images/check.svg')] [label_input:checked_~_&]:bg-center [label_input:checked_~_&]:bg-no-repeat" />
          {children}
        </label>
      ) : (
        <label
          className={cn("flex relative pl-9 cursor-pointer select-none", {
            [labelClassName as string]: !!labelClassName,
          })}
          htmlFor={props.id || name}
        >
          <input
            className="absolute opacity-0 pointer h-0 w-0"
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...field}
            // eslint-disable-next-line react/jsx-props-no-spreading
            {...props}
          />
          <span className="absolute top-1/2 left-0 h-6 w-6 -mt-3 border border-solid border-grey rounded bg-white [label_input:checked_~_&]:bg-[url('/images/check.svg')] [label_input:checked_~_&]:bg-center [label_input:checked_~_&]:bg-no-repeat" />
          {label}
        </label>
      )}
    </span>
  );
};

export default CheckboxInput;
